import React from "react";
import { Carousel } from "react-bootstrap";
import img1 from "../../../images/banner/banner-1.jpg";
import img2 from "../../../images/banner/banner-2.jpeg";
import img3 from "../../../images/banner/banner-3.jpeg";
import img4 from "../../../images/banner/banner-4.jpg";
import img5 from "../../../images/banner/banner-5.jpg";
import img6 from "../../../images/banner/banner-6.jpg";

const Banner = () => {
  return (
    <>
      <Carousel fade className="container rounded img-fluid">
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img1}
            alt="Second slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img2}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img3}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img4}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img5}
            alt="Third slide"
          />
        </Carousel.Item>
        <Carousel.Item>
          <img
            className="d-block w-100 img-fluid"
            src={img6}
            alt="Third slide"
          />
        </Carousel.Item>
      </Carousel>
    </>
  );
};

export default Banner;
